<form (ngSubmit)="submit()" ngNativeValidate>
  <div class="input-container">
    <div class="input-with-action">
      <label for="newLinkControl" class="hidden">{{
        content.actions.inputText
      }}</label>
      <input
        type="text"
        id="newLinkControl"
        trans-placeholder
        [placeholder]="content.actions.inputText"
        [formControl]="newLinkControl"
        [readonly]="activeLink$ | async"
        #input
        required
        (change)="onChange($event.target.value)"
        (blur)="onBlur($event.target.value)"
      />
      <button
        type="submit"
        class="submit-button"
        mat-flat-button
        [disabled]="loading$ | async"
      >
        <span *ngIf="activeLink$ | async; else noActiveLink" trans>Copy</span>
        <ng-template #noActiveLink>{{
          content.actions.inputButton
        }}</ng-template>
      </button>
    </div>
  </div>
  <div style="margin-top: 10px">
    By clicking SHORTEN, you are agreeing to JioSh's
    <a class="links" href="/pages/3/about-us">Terms of Service</a>,
    <a class="links" href="/pages/1/privacy-policy"> Privacy Policy</a>
    <!-- <a class="links" href="/pages/3/about-us"> Privacy</a> -->
  </div>
  <div class="div1" *ngIf="div1 == true">
    <div class="card">
      <div>
        <p class="long-link">{{ value }}</p>
      </div>
      <a
        [href]="activeLink$.value.short_url"
        target="_blank"
        style="margin-right: 8px"
        >{{ activeLink$.value.short_url }}</a
      >
      <button
        type="submit"
        class="submit-button"
        mat-flat-button
        [disabled]="loading$ | async"
        style="margin-top: 20px; margin-bottom: 20px"
      >
        <span trans>Copy</span>
        <ng-template #noActiveLink>{{
          content.actions.inputButton
        }}</ng-template>
      </button>
      <p class="successful">
        To see analytics, you'll need to <a href="/login">Login</a> or
        <a href="/register">Sign Up</a> to JioSh URL.<br />
        We provide detailed analytics of every short URL created on our
        platform.
      </p>
      <div class="base-btns">
        <button class="btn" (click)="login()" target="_blank" mat-flat-button>
          Login
        </button>
        <button class="btn" (click)="signin()" target="_blank" mat-flat-button>
          Sign Up
        </button>
        <button class="btn" (click)="pricing()" target="_blank" mat-flat-button>
          Check Our Plans
        </button>
      </div>
    </div>
  </div>
</form>
